import React, {useCallback, useContext, useEffect} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';
import ZeroRestored from './zero-restored';
import {useMenu} from '../../../hooks/useMenu';
import CommandsContext from '../../../context/commandsContext';

function FactoryZero({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onExit();
    onComponent(<ZeroRestored />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  return (
    <BodyContentView
      title="Restore Factory Zero"
      left="No"
      right="Yes"
      caption="Do you want to restore the factory zero?"
    />
  );
}

export default FactoryZero;
